<template>
  <ul class="sidebar-menu">
    <li class="header"></li>
    <router-link tag="li" class="pageLink" to="/movimientos">
      <a>
        <i class="fa fa-exchange-alt"></i>
        <span class="page">Movimientos</span>
      </a>
    </router-link>
    <router-link tag="li" class="pageLink" to="/productos">
      <a>
        <i class="fa fa-table"></i>
        <span class="page">Productos</span>
      </a>
    </router-link>
    <router-link tag="li" class="pageLink" to="/etiquetas">
      <a>
        <i class="fa fa-tag"></i>
        <span class="page">Etiquetas</span>
      </a>
    </router-link>
  </ul>
</template>
<script>
export default {
  name: 'SidebarMenu'
}
</script>
<style>
/* override default */
.sidebar-menu > li > a {
  padding: 12px 15px 12px 15px;
}

.sidebar-menu li.active > a > .fa-angle-left,
.sidebar-menu li.active > a > .pull-right-container > .fa-angle-left {
  animation-name: rotate;
  animation-duration: 0.2s;
  animation-fill-mode: forwards;
}

.treeview-title {
  z-index: 1;
}

@keyframes rotate {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(-90deg);
  }
}
</style>



// WEBPACK FOOTER //
// SidebarMenu.vue?3c36d79c